/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ThemeProvider from "@atg/icf-react-components/ThemeProvider";
import { PlatformId, ThemeMode } from "@atg/icf-react-components/themes/Theme";
import { FunctionComponent } from "react";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import ApiCaller, { initApiCallerInterceptors } from "~/api/ApiCaller";
import i18n from "~/setup/i18n";
import { createStore } from "~/state/store";
import { ComponentBaseProps } from "~/types";

const store = createStore();

initApiCallerInterceptors(ApiCaller, store);

const ContextProviders: FunctionComponent<ComponentBaseProps> = ({ children }) => {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider platformId={PlatformId.cambuilder} themeMode={ThemeMode.light}>
          <BrowserRouter>{children}</BrowserRouter>
        </ThemeProvider>
      </I18nextProvider>
    </Provider>
  );
};

export default ContextProviders;
